import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { APP_CONFIG } from '../../environment';
import { AddressLoqate } from '../../model/models/location/addressLoqate.interface';
import { FormValidatorType } from '../../providers/formbuilder/form-validator-type';
import { FormControlProvider } from '../../providers/formbuilder/formcontrol';
import { FormControlMapper } from '../../providers/formbuilder/formcontrol-mapper';
import { IFormControl } from '../../providers/formbuilder/formcontrol.interface';
import { InputType } from '../../providers/formbuilder/input-type';
import { LocationProvider } from '../../providers/location/location';
import { FORM_VALIDATION_NAMES, LOQATE_TYPES, LOQATE_RESPONSE_STATUS } from '../../providers/myria/app-variables';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { TranslateService } from '@ngx-translate/core';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { AnalyticsEventType } from '../../model/types/analytics.const';
import { SegmentProvider } from '../../providers/analytics/segment';
import { LoqateProvider } from '../../providers/loqate/loqate-provider';
const ADDRESS_STEP = 1;

@Component({
  selector: 'rmt-loqate',
  templateUrl: 'rmt-loqate.html'
})
export class RmtLoqateComponent {
  @ViewChild('searchbar') searchBar;
  @Output() emitFormFields: EventEmitter<any> = new EventEmitter();
  @Output() emitDisplayForm: EventEmitter<any> = new EventEmitter();
  @Output() handleLoqateServiceError: EventEmitter<boolean> = new EventEmitter();
  @Input() inputStepFields: any[];
  @Input() allowManualInput: boolean= true;
  @Input() allowManualInputOnLoqateError: boolean = false;
  @Input() defaultAddress: string = "";
  @Input() isStaticFields: boolean = false
  @Input() disable: boolean = false;
  @Input() searchWithDefaultAddress: boolean = false;
  @Input() parentForm;
  @Input() title: string = '';
  addresses: any[] = [];
  stepsFields: any[];
  fields: IFormControl[];
  searchbarInput: string = "";
  currentSearchbar: string;

  displayForm: boolean = true;
  overlayTimeout = null;
  focusTimeout = null;
  enabledManualAddress: boolean = false;
  displaySpinner: boolean = false;
  noMatchTextAlert: boolean = false;
  inputTimeout: any;
  clickedInsideDiv: boolean = false;
  selectItem;
  manualSelectItem;
  errorMessage;
  searchAddressId;
  touched = false;
  focused = false;
  manually = false;
  avoidBlur = false;
  updateTextTimeout: any;
  loqateServiceNotAvailable : boolean | null = null;

  constructor(private locationProvider: LocationProvider,
    private formProvider: FormControlProvider,
    private utilsProvider: UtilsProvider,
    private analytics: SegmentProvider,
    private translate: TranslateService,
    private loqateProvider: LoqateProvider) {
    if (!this.title) {
      this.title = this.translate.instant('form.registrationForm.address.label');
    }
  }

  async ngAfterViewInit() {
    this.searchbarInput = this.defaultAddress ? this.defaultAddress.trim(): "";
    if(this.searchbarInput === undefined || this.searchbarInput === ""){
      this.displayForm = true;
    }
    this.selectItem = (item) => this.chooseItem(item);
    this.manualSelectItem = () => this.manuallyAddAddress();
    if(this.searchWithDefaultAddress === true){
      this.avoidBlur = true;
      this.inputSearch();
    } 
    this.setFocusOnInput();
  }

  async ngOnInit() {
    await this.initFields();
  }

  async initFields() {
    if(this.isStaticFields) {
      return;
    }
    if(!this.inputStepFields) {
        this.stepsFields = await this.formProvider.getFieldsDynamicRegistration();
        
    } else{
        this.stepsFields = this.inputStepFields;
    }
    
    const step = this.stepsFields[ADDRESS_STEP];
    let fieldPostalCode = step.Fields.find(x => x.FieldId == "4801");
    this.fields = FormControlMapper.mapCategoryToFields(step);

    if(fieldPostalCode) {
      let validations = [];
      validations = fieldPostalCode.FieldValidations.filter(x => x.Type == FormValidatorType.Required);
      validations.push({Type: FORM_VALIDATION_NAMES.REGEX, Value: APP_CONFIG.region.postalCodeRegex, Message: null});
      fieldPostalCode.FieldValidations = validations;
    }

    for (let i=0; i < this.fields.length; i++) {
      const field = this.fields[i];        
      if (field.label) {
        const pos = field.label.indexOf('(');
        if (pos > 0)
          field.label = field.label.substr(0, pos);
      }
       if (field.id === '4801') { // Postal code
        let numeric = true;
        for (let i=0; i < field.validators.length; i++) {
          const validator = field.validators[i];
          if (validator.type === FormValidatorType.Required)
            continue;
          else if (validator.type === FormValidatorType.MinLength && validator.minLength && validator.minLength.toString() === "5")
            continue;
          else if (validator.type === FormValidatorType.MaxLength && validator.maxLength && validator.maxLength.toString() === "5")
            continue;
          numeric = false;
          if (!numeric)
            break;
        }
        if (numeric && field.type === InputType.Text)
          field.type = InputType.Number;
      }      
      if (field.id === '4901') { // Country (move it to the first position in the array)
        this.fields.splice(i, 1);
        this.fields.unshift(field);
        field.disabled = true;
      }
    }
  }

  clearOverlayTimer() {
    if (this.overlayTimeout)
      window.clearTimeout(this.overlayTimeout);
    this.overlayTimeout = null;
  }

  startOverlayTimer() {
    if (!this.overlayTimeout)
      this.overlayTimeout = window.setTimeout(() => {
        this.displayForm = false;
        this.overlayTimeout = null;
      }, 1000); // should be 2 seconds but because of other involved timeouts we lose already 300ms and 2 seconds feels too long
  }

  async getAddressList(addressId?: string) {
    let searching = '';
    let noMatchTextAlert = false;
    try {
      if(!this.fields)
        await this.initFields();
      
      this.displaySpinner = true;
      this.enabledManualAddress = true;

      if (this.displayForm)
        this.startOverlayTimer();
      this.emitDisplayForm.emit(this.displayForm);

      searching = this.searchbarInput;
      this.searchAddressId = addressId;

      const address = await this.locationProvider.getLoqateAddress(this.searchbarInput, addressId);
      this.addresses = address['Addresses'];

      if(this.addresses.length === 0) {
        noMatchTextAlert = true;
      }

      if (this.allowManualInputOnLoqateError && address['RetVal'] === LOQATE_RESPONSE_STATUS.MANUAL_ADDRESS_ENABLED) {
        this.onLoqateError();
      }

    } catch(ex) {
      if (this.allowManualInputOnLoqateError) {
        this.onLoqateError();
      }

      this.addresses = []; 
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Exception during get loqate address');
      noMatchTextAlert = true;
      // RmtPopupComponent.showException(this, ex, this.translate.instant('page.registrationStep3Page.addressNotFoundError')); 
    }

    if (!this.focused)
      this.clearOverlayTimer();
    if (!searching || searching !== this.searchbarInput || this.searchAddressId !== addressId)
      return;

    this.clearOverlayTimer();
    this.displaySpinner = false;
    this.noMatchTextAlert = noMatchTextAlert;

    if (!this.focused)
      return;

    this.displayForm = false;
  }
  
  formatAddressDescription(description) {
    let addrDescription = description ? description.trim() : "";
    if(addrDescription && addrDescription.charAt(0) === '-') {
      addrDescription = addrDescription.substring(1);
      addrDescription = addrDescription.trim();
    }
    return addrDescription
  }

  mapValuesToFields(values) {
    this.fields.forEach(field => {
      values['Fields'].forEach(value => {
        if(field.id == value.FieldId){
          field.value = value.Value;
        }
      });
    });
  }

  mapValuesToFieldsNonDynamic(values) {
      let fieldObj = {};
      values['Fields'].forEach(value => {
          fieldObj[value.FieldId] = value.Value; 
      });
      return fieldObj;
  }

  async chooseItem(address: AddressLoqate) {
    this.displaySpinner = true;
    this.clickedInsideDiv = true;
    const inputField = this.getNativeInputField();
    
    if (inputField) {
      inputField.classList.add('active');
      window.requestAnimationFrame(() => {
        inputField.focus();
      });
    }

    if(address.Type == LOQATE_TYPES.ADDRESS) {
      try {
        this.searchbarInput = address.Text;
        this.loqateProvider.setAddressSource(true);

        let fields;
        this.currentSearchbar = null;
        const values = await this.locationProvider.getLoqateAddressValues(address.Id);
        if(this.isStaticFields) {
          fields = this.mapValuesToFieldsNonDynamic(values);
        } else {
          this.mapValuesToFields(values);
          fields = this.fields;
        }
        this.setAddressFiledText(fields, address)
        this.emitEventAndCallBlur(inputField, fields);
        this.displaySpinner = false;
      } catch(ex) {
        this.displaySpinner = false;
        RmtPopupComponent.showException(this, ex, 'Failed to get address values');
      }
    }
    else {
      this.getAddressList(address.Id);
    }
  }

  focus() {
    if (this.focusTimeout)
      window.clearTimeout(this.focusTimeout);

    this.touched = true;
    this.focused = true;

    if (!this.manually) {
      if (this.noMatchTextAlert || (this.addresses && this.addresses.length > 0)) {
        this.clearOverlayTimer();
        this.displayForm = false;
      }
    }
  }

  blur(ev) {
    if(this.avoidBlur === true){
      this.avoidBlur = false;
      this.setFocusOnInput();
      return;
    }
    this.focused = false;
    if (this.clickedInsideDiv) {
      this.clickedInsideDiv = false;
    } else {
      this.clearOverlayTimer();
      this.displayForm = true;
    }
    if(this.searchWithDefaultAddress !== true){  // Adding this to avoid emitting changes to next levels in case of updating address from settings and verification from other places
      this.emitAddressChange();
    }
    
    this.checkErrorMessage();
  }

  inputSearch() {
    if(this.disable){
      return;
    }
    if(this.inputTimeout) clearTimeout(this.inputTimeout)
    this.searchbarInput = this.utilsProvider.removeEmojisFromString(this.searchbarInput);

    this.checkErrorMessage();
    if(this.searchWithDefaultAddress !== true){  // Adding this to avoid emitting changes to next levels in case of updating address from settings and verification from other places
      this.emitAddressChange();
    }
    if (this.manually){
      return;
    }
    if (!this.searchbarInput || this.searchbarInput === "" || this.searchbarInput === '') {
      this.noMatchTextAlert = false;
      this.addresses = [];
      this.displaySpinner = false;
    } else if (this.currentSearchbar !== this.searchbarInput) {
      this.currentSearchbar = this.searchbarInput;        
      this.inputTimeout = setTimeout(async () => {
        if(this.searchbarInput === this.currentSearchbar) {
          this.getAddressList();
        }
      }, 300);
    }
  }

  checkErrorMessage() {
    if (this.updateTextTimeout)
      window.clearTimeout(this.updateTextTimeout);
    this.updateTextTimeout = setTimeout(() => {
      let isAddressFieldValid = true;
      this.errorMessage = '';
      let inputField = this.searchBar.getInputField();
      if(inputField){
        inputField.isErrorHidden = true;
        inputField.showForcedError = false;
      }
      if(this.parentForm && this.parentForm.controls && this.parentForm.controls[4501] && !this.parentForm.controls[4501].valid){
        if (this.parentForm.controls[4501].value && this.disable) {
          // seems valid is always false when it's disabled hence as long as we have a value don't show an error
        } else {
          isAddressFieldValid = false;
        }
      }
      if (this.touched && (!this.searchbarInput || !isAddressFieldValid)) {
        this.errorMessage = this.translate.instant('page.registrationFinishPage.invalidAddressMessage');
        if (this.searchBar) {
          if (inputField) {
            window.requestAnimationFrame(() => {
              inputField.isErrorHidden = false;
              inputField.showForcedError = true;
            });
          }
        }
      }
    }, 200);
  }

  getAddressName(addressName) {

    let result = "";
    if(this.searchBar && this.searchbarInput)
    result = this.utilsProvider.highlightMatchSearchResult(addressName, this.searchbarInput)

    return result;

  }

  sendManualAddressEvent() {
    this.analytics.trackEvent({eventName: AnalyticsEventType.ManualAddressTapped, analyticsData: {
      brand: APP_CONFIG.branding.segmentProduct,
      product: "App",
      productVariant: null,
    }});
  }

  manuallyAddAddress() {
    this.clearOverlayTimer();
    this.displayForm = true;
    this.manually = true;
    
    if (this.fields) {
      this.fields.forEach(field => {
        if(field.id !== '4901'){
          field.value = "";
        }
        if(field.id == '4501'){
          field.value = this.searchbarInput;
        }
      });
    }
    
    this.emitFormFields.emit(this.fields);
    const inputField = this.getNativeInputField();    
    if (inputField) {
      window.requestAnimationFrame(() => {
        inputField.focus();        
      });
    }

    this.sendManualAddressEvent();

    if (this.loqateServiceNotAvailable)
      this.handleLoqateServiceError.emit();
  }

  clear() {
    this.manually = false;
    this.displayForm = true;
    this.searchbarInput = '';
    this.addresses = [];
    this.noMatchTextAlert = false;
    this.clearOverlayTimer();
    window.requestAnimationFrame(() => {
      this.errorMessage = '';
    });
    if (this.parentForm) {
      for (var id in this.parentForm.controls) {
        this.parentForm.controls[id].setValue('');
      }
    }
  }

  getNativeInputField() {
    if (this.searchBar) {
      const inputField = this.searchBar.getInputField();
      if (inputField && inputField.inputField1)
        return inputField.inputField1.nativeElement;
    }
    return null;
  }

  setFocusOnInput(){
    if (this.focusTimeout)
      window.clearTimeout(this.focusTimeout);
    this.focusTimeout = setTimeout(() => {
      const inputField = this.getNativeInputField();
      inputField.focus();    
    }, 1000);
  }

  emitEventAndCallBlur(inputField, fields){
    this.clearOverlayTimer();
    this.displayForm = true;
    this.emitFormFields.emit(fields);
    this.clickedInsideDiv = false;
    if (inputField)
        inputField.blur();
  }

  emitAddressChange(){
    if(this.searchbarInput){
      this.searchbarInput = this.searchbarInput.trim()
    }
    if(this.isStaticFields === true){ // only in case of CA&US
      this.emitFormFields.emit({4501:this.searchbarInput});
    }else {
      this.emitFormFields.emit([{id:4501, value:this.searchbarInput}]);
    }
  }
  
  setAddressFiledText(fields, address){
    this.searchbarInput = address.Text;
    if(fields.length > 0){
      fields.forEach(field => {
        if(field.id == '4501'){
          this.searchbarInput = field.value;
        }
      });
    } else {
      if(fields['4501']){
        this.searchbarInput = fields['4501'];
      }
    }
  }

  private onLoqateError() {
    this.allowManualInput = true;
    this.loqateServiceNotAvailable = true;
    this.searchWithDefaultAddress = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-loqate/rmt-loqate.ts